import { eCommerceTrackEvent } from '@comeon/analytics';
import { Item } from '../types';

export const eCommerceCampaignImp = (items: Item[]) => {
	if (items) {
		eCommerceTrackEvent({
			event: 'EECpromotionImpression',
			eComObj: {
				promoView: {
					promotions: items.map((item, index) => {
						return {
							id: item.key || item.id,
							name: item.header || item.headerText || item.name,
							position: index + 1
						};
					})
				}
			}
		});
	}
};

export const eCommerceCampaignClick = (title: string, id: string | number, index: number) => {
	eCommerceTrackEvent({
		event: 'EECpromotionClick',
		eComObj: {
			promoClick: {
				promotions: [
					{
						id,
						name: title,
						position: index + 1
					}
				]
			}
		}
	});
};
